import { Collection } from 'modules/core/lib/mobx-rest'

import DefaultShift from 'modules/shift_management/store/api/models/DefaultShift'

class DefaultShifts extends Collection<DefaultShift> {
  get cacheKey(): string {
    return 'defaultShifts'
  }
  model() {
    return DefaultShift
  }
}

const singleton: DefaultShifts = new DefaultShifts()

export default singleton
